module.exports = __webpack_public_path__ + "static/img/nombre_zurqui_blanco.36fe58b3.png";